module.exports = __webpack_public_path__ + "img/teamImg10.4bf32684.jpg";